import { defineMessages } from 'react-intl';

export default defineMessages({
  connect: { defaultMessage: 'Connect' },
  connectWallet: { defaultMessage: 'Connect wallet' },
});
